
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenMetricSource } from './GenMetricSource';

export class GenMetricDetails {

    avg: number;
    county: string;
    dataYear: number;
    fipsCode: string;
    max: number;
    metric: string;
    min: number;
    outageId: string;
    source: GenMetricSource;
    stateAbbreviation: string;
    sum: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genMetricDetails: GenMetricDetails);

    constructor( input?: GenMetricDetails ) {
        if ( input && typeof input !== 'number' ) {
            this.avg = input.avg; // float [number]
            this.county = input.county; // string [string]
            this.dataYear = input.dataYear; // int [number]
            this.fipsCode = input.fipsCode; // string [string]
            this.max = input.max; // int [number]
            this.metric = input.metric; // string [string]
            this.min = input.min; // int [number]
            this.outageId = input.outageId; // string [string]
            this.source = (typeof input.source === 'string') ? GenMetricSource.forName(<string> input.source) : <any> input.source; // GenMetricSource
            this.stateAbbreviation = input.stateAbbreviation; // string [string]
            this.sum = input.sum; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenMetricDetails[] {
        if (arr && arr.map) {
          return arr.map(a => new GenMetricDetails(a));
        } else {
          return [];
        }
    }
}

